module.exports = __webpack_public_path__ + "static/media/secondLife.5ccfaae9.png";